import actions from "../constants/rtoRequestApprovalsActions";

export const getRtoRequestList = (data) => ({
  type: actions.GET_RTO_REQUEST_LIST,
  data,
});

export const getRtoRequestListClear = () => ({
  type: actions.GET_RTO_REQUEST_LIST_CLEAR,
});

export const updateRtoRequestStatusAction = (data) => ({
  type: actions.UPDATE_RTO_REQUEST_STATUS,
  data,
});

export const updateRtoRequestStatusClear = () => ({
  type: actions.UPDATE_RTO_REQUEST_STATUS_CLEAR,
});
